import { connect } from 'react-redux';

import { createArchiveEvent } from 'api/events/events.actions';
import { ArchiveEventModalContent } from './ArchiveEventModalContent';

const mapDispatchToProps = (dispatch: Function) => ({
  archiveEvent: (eventId: string, archived: boolean) =>
    dispatch(createArchiveEvent({ id: eventId, archived: !archived })),
});

export const ArchiveEventModalContentContainer = connect(null, mapDispatchToProps)(ArchiveEventModalContent);
